import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import H3 from "../../../elements/titles/H3";
import Paragraph from "../../../elements/p/Paragraph";
import LazyLoadImg from "../../../elements/images/LazyLoadImg";
import { IoMdClose } from "react-icons/io";
import modalContext from "../../../../dataManager/context/modalContext";
import {
  FaLinkedinIn,
  FaTwitter,
  FaWhatsapp,
  FaFacebookF,
} from "react-icons/fa";

import {
  shareOnFacebook,
  shareOnLinkedIn,
  shareOnWhatsapp,
  shareOnTwitter,
} from "../../../../functions/social";

const ProductItem = ({ product }) => {
  //context variables
  const { handleOpenModal } = useContext(modalContext);
  const navigate = useNavigate();

  const { id, image, name, description } = product;

  const handleClick = (e) => {
    //stop onclick propagation
    e.stopPropagation();

    //open unsave modal
    handleOpenModal("UNSAVE_PRODUCT", "Rétirer des favories", {
      productId: product.getId,
    });
  };

  const shareProduct = (e, shareFunction, articleName = "") => {
    e.stopPropagation();

    shareFunction(e, window.location.href, articleName);
  };

  return (
    <article
      onClick={() => navigate(`/produits/${id}`)}
      className="animate relative flex max-w-lg cursor-pointer items-center space-x-3 rounded bg-smoot p-5 hover:opacity-90  md:p-8"
    >
      <div className="max-h-32 w-1/5 shrink-0">
        <LazyLoadImg
          classe="w-full block max-h-20 max-w-20"
          img={image}
          alt={name}
        />
      </div>
      <div>
        <H3 classe="line-clamp-1">{name}</H3>
        <Paragraph classe="text-left line-clamp mt-0.5" size="small">
          {description}
        </Paragraph>
        <div className="mt-2 flex items-center space-x-1">
          <Paragraph classe="hidden md:block">| Partager |</Paragraph>
          <div className="flex items-center justify-between space-x-2 text-secondary/80 md:justify-start md:space-x-3">
            <FaWhatsapp
              onClick={(e) => shareProduct(e, shareOnWhatsapp)}
              className="animate hover:text-primary"
            />
            <FaTwitter
              onClick={(e) => shareProduct(e, shareOnTwitter, product.getName)}
              className="animate hover:text-primary"
            />
            <FaFacebookF
              onClick={(e) => shareProduct(e, shareOnFacebook)}
              className="animate hover:text-primary"
            />
            <FaLinkedinIn
              onClick={(e) => shareProduct(e, shareOnLinkedIn)}
              className="animate hover:text-primary"
            />
          </div>
        </div>
      </div>
      <div
        onClick={handleClick}
        className="animate absolute top-0 right-0 flex h-6 w-6 items-center justify-center rounded-tr bg-primary/70 hover:bg-primary-dark"
      >
        <IoMdClose className="text-white" />
      </div>
    </article>
  );
};

export default ProductItem;
